export default "__VITE_ASSET__2d7b673f__"